import { createContext, useContext } from "react";
export const InterviewContext = createContext(null);
export function useInterviewAPI() {
    const api = useContext(InterviewContext);
    if (!api) {
        throw new Error("useInterviewAPI must be used within an InterviewProvider");
    }
    return api;
}
